import { useContext, useEffect } from "react";
import { AuthContext, LocationContext } from "../../contexts";
import authService from "../../services/auth/auth.service";
import AuthContainer from "./authContainer";

const Login = () => {
  const { location, urlParams } = useContext(LocationContext);
  const auth = useContext(AuthContext);

  useEffect(() => {
    if (!auth.user && location.pathname !== "/sign-up") {
      authService.authorizeSafetyCultureAuth0(
        location.pathname,
        urlParams?.visitor_role,
      );
    }
  }, [auth.user, location.pathname]);

  return <AuthContainer></AuthContainer>;
};

export default Login;
